import { useMemo } from 'react';
import { useAuthContext } from '../contexts/AuthContextProvider';
import { collectAssignedRoles, resolveAdminPermissions } from '../config/admin-roles';

export function useAdminAccess() {
    const { getUserRoles, getUserAccount } = useAuthContext();
    const contextRoles = getUserRoles();
    const tokenRoles = getUserAccount()?.idTokenClaims?.['roles'];

    return useMemo(
        () => resolveAdminPermissions(collectAssignedRoles(contextRoles, tokenRoles)),
        [contextRoles, tokenRoles],
    );
}
